import { __rest } from "tslib";
import React, { useState } from 'react';
import { Input } from 'antd';
import classnames from 'classnames';
import { omit } from 'lodash';
import './input.scss';
const { TextArea, Group, Password, Search } = Input;
export const prefixCls = 'sirius-input';
const Component = (props, ref) => {
    const { className, size, suffix, prefix, openFix } = props, rest = __rest(props, ["className", "size", "suffix", "prefix", "openFix"]);
    const restProps = omit(rest);
    const renderSuffix = React.useMemo(() => {
        if (openFix)
            return React.createElement(React.Fragment, null, suffix);
        else
            return suffix && React.createElement("div", { className: `${prefixCls}-suffix` }, suffix);
    }, [openFix, suffix]);
    const renderPrefix = React.useMemo(() => {
        if (openFix)
            return React.createElement(React.Fragment, null, prefix);
        else
            return prefix && React.createElement("div", { className: `${prefixCls}-prefix` }, prefix);
    }, [openFix, prefix]);
    const fixProps = React.useMemo(() => {
        const props = {};
        if (suffix) {
            props['suffix'] = renderSuffix;
        }
        if (prefix) {
            props['prefix'] = renderPrefix;
        }
        return props;
    }, [suffix, prefix, renderSuffix, renderPrefix]);
    const inputProps = Object.keys(fixProps).length ? Object.assign(Object.assign({}, restProps), fixProps) : restProps;
    return React.createElement(Input, Object.assign({ ref: ref }, inputProps, { className: classnames(className, `${prefixCls}`, `${prefixCls}-${size}`) }));
};
const ITextArea = React.forwardRef((props, ref) => {
    const { onChange, maxLength, className, disabled } = props;
    const [max, setMax] = useState(false);
    return (React.createElement("span", { className: classnames(prefixCls) },
        React.createElement(TextArea, Object.assign({}, props, { className: classnames(className, {
                [`${prefixCls}-max-count`]: max,
                [`${prefixCls}-disable`]: disabled,
            }), onChange: e => {
                const val = e.currentTarget.value;
                onChange && onChange(e);
                if (!maxLength)
                    return;
                if ((val === null || val === void 0 ? void 0 : val.length) >= maxLength) {
                    setMax(true);
                }
                else {
                    setMax(false);
                }
            }, ref: ref }))));
});
const InputRef = React.forwardRef(Component);
const InputComponent = InputRef;
InputComponent.TextArea = ITextArea;
InputComponent.Group = Group;
InputComponent.Password = Password;
InputComponent.Search = Search;
InputComponent.defaultProps = {
    size: 'default',
    openFix: true,
};
export default InputComponent;
